export default __webpack_public_path__ + "static/media/details.feca4861.svg";